import { callNativeMessage } from "@bridge/callNative"

declare const __APP_VERSION__: string

export const getWebAppVersion = (requestId: string) => {
  return callNativeMessage({
    type: "response",
    handlerName: "getWebAppVersion",
    isSuccess: true,
    requestId,
    result: {
      version: __APP_VERSION__,
    },
  })
}
